import styled from '@emotion/styled';
import { commonColors } from 'application/theme';

interface StyledProps {
  width?: string;
  padding?: string;
  height?: string;
}

export const Wrapper = styled.div<StyledProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  outline: none;
  display: flex;
  min-width: 500px;
  min-height: ${({ height }) => (height?.length ? height : 'unset')};
  width: ${({ width }) => (width?.length ? width : '500px')};
  padding: ${({ padding }) => (padding?.length ? padding : '32px')};
  flex-direction: column;
  border-radius: 8px;
  background: ${commonColors.white};
  box-shadow: 0 10px 45px 0 rgba(14, 40, 83, 0.07);

  > svg {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 12px;
    top: 12px;
    cursor: pointer;

    path {
      fill: ${commonColors.grey500};
    }
  }
`;
